export default __webpack_public_path__ + "static/media/philip_harps_opt.6d15d0fd.jpg";